import { defaultStore } from '../../../../../translations'
import content from '../../constants/content'
import { PREM } from '../../constants/actions'

export default function useFilteredItems() {
  return content.items.filter(({ availableStores, action }) => {
    const isStoreAvailable = availableStores.includes(defaultStore)
    const isPremiumItem = action === PREM

    if (isPremiumItem) {
      return false
    }

    return isStoreAvailable
  })
}
